<template>
    <img v-lightbox.iframe="iframeSrc" :src="thumbSrc" alt="">
</template>

<script type="text/babel">
export default {
  name: 'LightBoxImage',
  data() {
    return {
      thumbSize: 500,
      imageSize: 2000,
    };
  },
  props: {
    src: {
      required: true,
    },
  },
  computed: {
    thumbSrc() {
      return this.src.thumb;
    },
    iframeSrc() {
      return `https://www.youtube.com/embed/${this.src.video_id}?rel=0&amp;controls=0&amp;showinfo=0&autoplay=1`;
    },
  },
  methods: {
    getThumb(url, size) {
      return url.replace(/(^(?!http)(?:(?!thumb).)*)\.(jpe?g|png|gif)/, `$1.${size}.$2`);
    },
  },
};
</script>

<style lang="scss">

</style>
